import { FC, useEffect, useState } from 'react';

import { Card, Col, Row, Form, FormGroup, Input, Label } from 'reactstrap';

/* eslint-disable jsx-a11y/anchor-is-valid */
import { shallowEqual, useSelector } from 'react-redux';
import { PageTitle } from '../../../_metronic/layout/core';
import { RootState } from 'setup';
import { getListKeyGoogle, getSetting, updateSetting } from 'app/modules/orders/redux/OrdersCRUD';
import { ROLE_GENERAL } from 'utils/constants'
import { Badge, Button, InputNumber, List, Tooltip } from 'antd';

import { KeyOutlined } from '@ant-design/icons';
import './styles.scss'
import { numberWithCommas } from 'utils/convert';
import { truncate } from 'lodash';
import { FiKey } from "react-icons/fi";
import { FcInfo } from "react-icons/fc";
import { AddKeyUpload } from './_modals/AddKeyUpload';

const SubscribeStatisticWidget: FC = () => {
  const [video_per_day, setVideoPerDay] = useState(0);
  const [cookies, setCookies] = useState('');
  const [max_next_day, setMaxNextDay] = useState(2);

  const [initLoading, setInitLoading] = useState(false);
  const [listKey, setListKey] = useState([]);
  const [isModalKey, setIsModalKey] = useState<Boolean>(false);

  const fetchSetting = async () => {
    const { data: result } = await getSetting();
    if (result && result.data) {
      setVideoPerDay(result.data.video_per_day);
      setCookies(result.data.cookies);
      setMaxNextDay(result.data.max_next_day);
    }
  }

  const fetchListGoogleKey = async () => {
    setInitLoading(true);
    const { data: result } = await getListKeyGoogle();
    if (result?.data) {
      setListKey(result?.data);
    }
    setInitLoading(false);
  }

  useEffect(() => {
    fetchSetting();
    fetchListGoogleKey();
  }, []);

  const clickUpdateSetting = async () => {
    if (window.confirm('Bạn có chắc chắn muốn cập nhật setting không') === true) {
      const setting = {
        video_per_day,
        cookies,
        max_next_day
      };

      const { data: result } = await updateSetting(setting);

      if (result?.setting) {
        alert('Cập nhật cấu hình thành công')
      }
    }
  }

  const handleMakeGoogleKey = () => {
    setIsModalKey(true);
  }

  return (
    <>
      <AddKeyUpload
        setIsModalOpen={setIsModalKey}
        isModalOpen={isModalKey}
      />
      <div className='row no-gutters'>
        <div className='col-xl-4 col-lg-6 col-sm-12'>
          <Card className='card-box pb-3 p-settingCard pl-4 pr-4'>
            {/* <div className='text-left font-weight-bold font-size-xl mb-0 mt-3 text-black'>
              Video Upload
            </div>
            <div className='divider mb-4 mt-2' />
            <Form className='text-left'>
              <div className='row'>
                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-6'>
                  <FormGroup>
                    <Label for='exampleEmail' className='required form-label '>
                      Số video upload 1 ngày / kênh
                    </Label>
                    <Input
                      id='video_per_day'
                      name='video_per_day'
                      className='form-control form-control-solid'
                      placeholder={'Số video upload 1 ngày'}
                      value={video_per_day}
                      type={'number'}
                      onChange={(e) => setVideoPerDay(parseInt(e.target.value))}
                    />
                  </FormGroup>
                </div>
                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-6'>
                  <FormGroup>
                    <Label for='exampleEmail' className='required form-label '>
                      Số video next 1 ngày / kênh
                    </Label>
                    <Input
                      id='max_next_day'
                      name='max_next_day'
                      className='form-control form-control-solid'
                      placeholder={'Số video upload 1 ngày'}
                      value={max_next_day}
                      type={'number'}
                      onChange={(e) => setMaxNextDay(parseInt(e.target.value))}
                    />
                  </FormGroup>
                </div>
              </div>
            </Form> */}
            <div className='text-left font-weight-bold font-size-xl mb-0 text-black'>
              Tác vụ chạy ngầm
            </div>
            <div className='divider mb-4 mt-2' />
            <div className='row mb-3'>
              <div className='col-6'>
                <p style={{ display: 'inline-flex' }}>
                  Crawler quét thông tin kênh (1h - 22h hằng ngày)
                  <Tooltip title="Chọn thời gian quét toàn bộ các kênh trong 1 ngày, chọn khoảng 1h tới 22h">
                    <FcInfo fontSize={20} style={{ marginTop: '2px' }} />
                  </Tooltip>
                </p>
                <InputNumber addonBefore="Hằng ngày lúc" addonAfter="h" min={1} max={22} step={1} defaultValue={12} value={21} />
              </div>
            </div>

            <div className='text-left'>
              <Button size="middle" type="default" color='green' onClick={clickUpdateSetting}>
                {'Cập nhật cấu hình'}
              </Button>
            </div>
          </Card>
        </div>
        <div className='col-xl-4 col-lg-6 col-sm-12 ml-4'>
          <Card className='card-box pb-3 p-settingCard pl-4 pr-4'>
            <div className="row">
              <div className='col-6'>
                <div className='text-left font-weight-bold font-size-xl mb-0 mt-3 text-black' style={{ display: 'inline-flex' }}>
                  Google API Key
                  <Tooltip title="Key sử dụng để lấy dữ liệu các kênh Youtube">
                    <FcInfo fontSize={18} style={{ marginTop: '7px', marginLeft: '5px' }} />
                  </Tooltip>
                </div>
              </div>
              <div className='col-6'>
                <div className='text-right mt-3 mb-0'>
                  <Button className='mr-1' title='Tạo key' style={{ display: 'inline-flex' }} onClick={() => handleMakeGoogleKey()}>
                    <FiKey fontSize={17} className='mt-1 mr-2' />
                    Tạo Key
                  </Button>
                </div>
              </div>
            </div>

            <div className='divider mb-4 mt-2' />

            <List
              className="demo-loadmore-list"
              loading={initLoading}
              itemLayout="horizontal"
              dataSource={listKey}
              renderItem={(item: any, index: number) => (
                <List.Item
                  key={item?.id}
                  actions={[
                    <a key="edit-key">{item?.status === 0 ? 'Bật' : 'Tắt'}</a>,
                    <a key="remove-key">Xóa</a>,
                    <a key="healthcheck-key">Check</a>
                  ]}
                >
                  <List.Item.Meta
                    avatar={<KeyOutlined rev={undefined} />}
                    title={
                      <>
                        <Tooltip title={item?.key_site}>
                          <p className='mx-0 my-0' style={{  }}>{truncate(item?.key_site)}</p>
                        </Tooltip>
                      </>
                    }
                    description={<>
                      <div>
                        <Badge
                          showZero
                          status={item?.status === 1 ? 'success' : 'default'}
                          style={{ borderRadius: '4px', }}
                          className='mr-2'
                          count={item?.status === 1 ? 'Sử dụng' : 'Tắt'}
                        />
                        <span>
                          Sử dụng <strong>{numberWithCommas(item?.used_count || 0)}</strong> • Lỗi {item?.error_count} • Thử lại {item?.attempt_today}
                        </span>
                      </div>
                    </>}
                  />
                </List.Item>
              )}
            />
          </Card>
        </div>
      </div>
    </>
  )
}

const SettingWrapper: FC = () => {
  const role: string = (useSelector<RootState>(({ auth }) => auth?.user?.role, shallowEqual) as string) || ''

  return (
    <>
      <PageTitle breadcrumbs={[]}>{'Cài đặt'}</PageTitle>
      {(role === ROLE_GENERAL.ADMIN || role === ROLE_GENERAL.SUPER_ADMIN) ? (
        <Row>
          <Col lg='12'>
            <SubscribeStatisticWidget />
          </Col>
        </Row>
      ) : null}
    </>
  )
}

export { SettingWrapper }
